module.exports = __webpack_public_path__ + "static/media/sell_family_plan.ab618854.jpg";